import { ModelBase } from '../shared/model.base';
import { GrupoDTO } from '../groups/grupoDTO.type';
import { ShortCode } from '../shared/shortcode.type';
import { ContentSAT } from './contentSAT.type';
import { User } from '../security/user.type';

export class SatInstantDTO extends ModelBase {

    name: string;
    groups: GrupoDTO[];
    istracking: boolean;
    initTracking: boolean;
    shortCode: ShortCode;
    msisdn: string[];

    service_type: string;

    user: User;

    contents: Array<ContentSAT>;


    constructor() {
        super();
        this.groups = new Array<GrupoDTO>();
        this.msisdn = new Array<string>();
        this.name = '';
        this.istracking = false;
        this.initTracking = false;
        this.service_type = '0';


    }
}
